export default "__VITE_ASSET__c0bbc4f7__"